<script>
import LayoutLoose from "@/router/layouts/LayoutLoose";
import appConfig from "@/app.config";

import {mapState} from "vuex";
import {HalfCircleSpinner} from "epic-spinners";

export default {
  page: {
    title: "Server",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    LayoutLoose,
    Skeleton: () => import('@/components/lazy/servers/dashboard/Skeleton')
  },
  data() {
    return {
      server_id: this.$route.params.server_id
    }
  }
};
</script>

<template>
  <LayoutLoose>
    <Skeleton :server_id="server_id" />
  </LayoutLoose>
</template>